import script from "./ProductsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsSection.vue?vue&type=script&setup=true&lang=js"

import "./ProductsSection.vue?vue&type=style&index=0&id=417eb15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-417eb15c"]])

export default __exports__